/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secure_EmailInputs */

const en_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Email`)
};

const es_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico seguro`)
};

const fr_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail sécurisé`)
};

const de_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichere E-Mail`)
};

const ja_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全なメールアドレス`)
};

const zh_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全电子邮箱`)
};

const ar_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بريد إلكتروني آمن`)
};

const id_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Aman`)
};

const it_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail Sicura`)
};

const ru_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасный Email`)
};

const pt_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail Seguro`)
};

const ko_secure_email = /** @type {(inputs: Secure_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안 이메일`)
};

/**
* | output |
* | --- |
* | "Secure Email" |
*
* @param {Secure_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const secure_email = /** @type {((inputs?: Secure_EmailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secure_EmailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secure_email(inputs)
	if (locale === "es") return es_secure_email(inputs)
	if (locale === "fr") return fr_secure_email(inputs)
	if (locale === "de") return de_secure_email(inputs)
	if (locale === "ja") return ja_secure_email(inputs)
	if (locale === "zh") return zh_secure_email(inputs)
	if (locale === "ar") return ar_secure_email(inputs)
	if (locale === "id") return id_secure_email(inputs)
	if (locale === "it") return it_secure_email(inputs)
	if (locale === "ru") return ru_secure_email(inputs)
	if (locale === "pt") return pt_secure_email(inputs)
	return ko_secure_email(inputs)
});